import React, { Component } from "react";
import _ from "lodash";
import Loading from "../../common/components/loading/loading";
import { getHoldings } from "../../common/services/marketdata/bcEnvironmentalService";
import SearchBox from "../../common/components/search/searchBox";
import { formatDate } from "../../common/services/utilities";
import { withTranslation } from "react-i18next";
import BCEnvironmentalRegistryTable from "./bcEnvironmentalRegistryTable";
import Select from "../../common/components/form/select";
import * as XLSX from "xlsx";
import FontAwesome from "react-fontawesome";
import LifecycleChart from "./lifecycleChart";
import PieChart from "./pieChart";

class BCEnvironmentalRegistry extends Component {
  state = {
    registry: [],
    searchQuery: "",
    projectTypes: [],
    projectType: "All",
    vintages: [],
    vintage: "All",
    statuses: [],
    status: "All",
    sortColumn: { path: "TransactionId", order: "desc" },
    isLoading: true,
    reloading: false,
  };

  async componentDidMount() {
    await this.loadData();
  }

  async loadData() {
    const registry = await getHoldings();

    const projectTypes = [{ projectType: "All" }].concat(
      [
        ...new Set(
          registry.filter((x) => x.projectType).map((x) => x.projectType)
        ),
      ]
        .sort()
        .map((x) => ({ projectType: x }))
    );

    const statuses = [{ status: "All" }].concat(
      [...new Set(registry.filter((x) => x.status).map((x) => x.status))]
        .sort()
        .map((x) => ({ status: x }))
    );
    const vintages = [{ vintage: "All" }].concat(
      [...new Set(registry.filter((x) => x.vintage).map((x) => x.vintage))]
        .sort()
        .map((x) => ({ vintage: x }))
    );

    this.setState({
      registry: registry,
      isLoading: false,
      reloading: false,
      projectTypes: projectTypes,
      statuses: statuses,
      vintages: vintages,
    });
  }

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handleprojectTypeChange = (projectType) => {
    this.setState({ projectType: projectType });
  };

  handleVintageChange = (vintage) => {
    this.setState({ vintage: vintage });
  };

  handleStatusChange = (status) => {
    this.setState({ status: status });
  };

  downloadExcel = (data) => {
    const excelData = data.map((record) => ({
      ProjectName: record.projectName,
      AccountName: record.accountName,
      Location: record.location,
      Quantity: record.holdingQuantity,
      StandardName: record.standardName,
      Vintage: record.vintage,
      ProjectType: record.projectType,
      MonitoringPeriodStart: record.monitoringPeriodStart
        ? formatDate(record.monitoringPeriodStart)
        : null,
      MonitoringPeriodEnd: record.monitoringPeriodEnd
        ? formatDate(record.monitoringPeriodEnd)
        : null,
      Status: record.status,
      VerifierCompany: record.verifierName,
      SerialNo: record.serialNo,
      UnitType: record.unitType,
      UnitMeasurementName: record.unitMeasurementName,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "BCEnvironmentalRegistry.xlsx");
  };

  getFilteredData = () => {
    const {
      searchQuery,
      sortColumn,
      projectType,
      vintage,
      status,
      registry: allRegistry,
    } = this.state;

    let filtered = allRegistry;

    if (projectType !== "All") {
      filtered = filtered.filter(
        (u) => u.projectType === projectType ?? u.projectType
      );
    }

    if (status !== "All") {
      filtered = filtered.filter((u) => u.status === status ?? u.status);
    }

    if (vintage !== "All") {
      filtered = filtered.filter((u) => u.vintage === vintage ?? u.vintage);
    }

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          (u.accountName !== null &&
            u.accountName.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.projectName !== null &&
            u.projectName.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.location !== null &&
            u.location.toLowerCase().includes(searchQuery.toLowerCase()))
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: sorted.length, data: sorted };
  };

  render() {
    const {
      searchQuery,
      sortColumn,
      registry: unfilteredRegistry,
      projectTypes,
      projectType,
      vintages,
      vintage,
      // statuses,
      // status,
      isLoading,
      reloading,
    } = this.state;

    if (isLoading) return <Loading />;

    const { t, isSubscriber } = this.props;

    const { totalCount, data: registry } = this.getFilteredData();

    const uniqueStatusValues = [
      // "Retired",
      // "Retired for Compliance",
      // "Pending Retirement",
      // "Pending Retirement Compliance CSA Approval",
      // "Pending Retirement Federal OBPS CSA Approval",
      // "Pending Retire - Federal OBPS",
      "Active",
      // "Removed",
      // "Revoked",
      // "Cancelled",
      // "Locked In Transaction",
      // "Retire - Federal OBPS",
    ];
    const ColorScheme = [
      // "grey",
      // "darkgrey",
      // "orange",
      // "darkorange",
      // "goldenrod",
      // "gold",
      "darkgreen",
      // "black",
      // "red",
      // "darkred",
      // "green",
      // "darkblue",
    ];
    const Vintages = Array.from(
      new Set(unfilteredRegistry.map((item) => item.vintage))
    ).sort((a, b) => a - b);

    const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12 d-flex align-items-center justify-content-center">
            <h1>{t("BCEnvironmentalRegistry")}</h1>
          </div>
          <div className="row">
            <div className="col-md-3" style={{ alignSelf: "flex-end" }}>
              <SearchBox
                value={searchQuery}
                onChange={this.handleSearch}
                disabled={!isSubscriber}
              />
            </div>
            {/* <div className="col-md-2">
              <Select
                idField="status"
                optionField="status"
                name="status"
                //disabled={Object.keys(organizations).length < 2}
                value={status}
                label={t("Status")}
                options={statuses}
                onChange={(e) => this.handleStatusChange(e.currentTarget.value)}
                disabled={!isSubscriber}
              />
            </div> */}
            <div className="col-md-1">
              <Select
                idField="vintage"
                optionField="vintage"
                name="vintage"
                //disabled={Object.keys(organizations).length < 2}
                value={vintage}
                label={t("Vintage")}
                options={vintages}
                onChange={(e) =>
                  this.handleVintageChange(e.currentTarget.value)
                }
                disabled={!isSubscriber}
              />
            </div>
            <div className="col-md-2">
              <Select
                idField="projectType"
                optionField="projectType"
                name="projectType"
                //disabled={Object.keys(organizations).length < 2}
                value={projectType}
                label={t("ProjectType")}
                options={projectTypes}
                onChange={(e) =>
                  this.handleprojectTypeChange(e.currentTarget.value)
                }
                disabled={!isSubscriber}
              />
            </div>
            <div className="col-md-5"></div>
            <div className="col-md-1" style={{ alignSelf: "flex-end" }}>
              <button
                className="btn btn-sm btn-primary"
                onClick={() => this.downloadExcel(registry)}
                disabled={!isSubscriber}
              >
                <FontAwesome name="download" /> {t("Excel")}
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <p>
              {t("RetrievedAlbertaEnvironmentalRegistry", {
                count: totalCount,
              })}
            </p>
          </div>
          {!isSubscriber && (
            <div
              className="col-md-8 d-flex align-items-center justify-content-center"
              style={{ fontStyle: "italic", color: "darkred" }}
            >
              <p>
                {t("SubscriptionInquiry")}{" "}
                <a href={"mailto:" + contactEmail}>{contactEmail}</a>
              </p>
            </div>
          )}
        </div>
        {!reloading && (
          <>
            <div className="row">
              <div className="col-md-3 tile">
                <PieChart
                  data={registry}
                  title="Offsets by Owner"
                  groupBy="accountName"
                />
              </div>
              <div className="col-md-3 tile">
                <PieChart
                  data={registry}
                  title="Offsets by Location"
                  groupBy="location"
                />
              </div>
              <div className="col-md-3 tile">
                <PieChart
                  data={registry}
                  title="Offsets by Project Type"
                  groupBy="projectType"
                />
              </div>
              <div className="col-md-3 tile">
                <PieChart
                  data={registry}
                  title="Offsets by Verifier"
                  groupBy="verifierName"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 tile">
                <LifecycleChart
                  data={registry}
                  title="Status by Vintage"
                  uniqueStatusValues={uniqueStatusValues}
                  colorScheme={ColorScheme}
                  vintages={Vintages}
                />
              </div>
            </div>
            <div className="col-md-12" style={{ paddingBottom: "30px" }}>
              <BCEnvironmentalRegistryTable
                registry={registry}
                sortColumn={sortColumn}
                onSort={this.handleSort}
              />
            </div>
          </>
        )}
        {reloading && <Loading />}
      </div>
    );
  }
}

export default withTranslation(["marketdata"])(BCEnvironmentalRegistry);
